import { render, staticRenderFns } from "./VepContainer.vue?vue&type=template&id=0baab719&scoped=true"
import script from "./VepContainer.vue?vue&type=script&lang=ts"
export * from "./VepContainer.vue?vue&type=script&lang=ts"
import style0 from "./VepContainer.vue?vue&type=style&index=0&id=0baab719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baab719",
  null
  
)

export default component.exports